export default "__VITE_ASSET__CO3M5dDe__"